// src/features/availableDaysSlice.js
import { createSlice } from '@reduxjs/toolkit';

const availableDaysSlice = createSlice({
  name: 'availableDays',
  initialState: {
    days: [],
  },
  reducers: {
    setAvailableDays: (state, action) => {
      state.days = action.payload;
    },
  },
});

export const { setAvailableDays } = availableDaysSlice.actions;
export default availableDaysSlice.reducer;
